import { Slider } from "@circle-react-shared/uikit/Slider";

export interface CropSliderProps {
  onChange: (value: number | number[]) => void;
  value: number;
}

export const CropSlider = ({ value, onChange }: CropSliderProps) => (
  <div>
    <Slider.Root
      value={[value]}
      onValueChange={onChange}
      min={1}
      max={3}
      step={0.1}
      aria-labelledby="Zoom"
      className="!bg-secondary-dark"
    >
      <Slider.Track>
        <Slider.Range />
      </Slider.Track>
      <Slider.Thumb />
    </Slider.Root>
  </div>
);
